// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2vx_D","alert":"SettungsInbox_alert__1UxPz"};